import { ChangeEvent, InputHTMLAttributes } from "react";

export type BasicRadioInputProps<T extends string | number> = {
  onChange: (value: T) => void;
  value: T;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "value">;

function BasicRadioInput<T extends string | number>({
  onChange,
  value,
  ...props
}: BasicRadioInputProps<T>) {
  const onChangeHandler = (_e: ChangeEvent<HTMLInputElement>) => {
    if (value != null) {
      onChange(value);
    }
  };
  return <input onChange={onChangeHandler} value={value} {...props} />;
}

export default BasicRadioInput;
